/* global Cookiebot */

export default function() {

  /**
  * Query the existence of the target element. If the element does not
  * exist, stop executing the function.
  */

  let videos = document.querySelectorAll('.c-video');

  if (!videos) { return; }

  videos.forEach(video => {
    let button = video.querySelector('.c-button[href*="#video"]');
    let videoPlayer = video.querySelector('video');

    window.addEventListener('CookiebotOnAccept', function () {
      if (!Cookiebot.consent.marketing) return;
      // Update video source if cookie consent given
      if (videoPlayer.querySelector('source').dataset.videoSrc) {
        let source = document.createElement('source');

        source.setAttribute('src', videoPlayer.querySelector('source').dataset.videoSrc);
        source.setAttribute('type', 'video/mp4');
        videoPlayer.appendChild(source);
      }
    }, false);

    if (!button) { return; }
    if (!videoPlayer) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', function(e){
      e.preventDefault();
      videoPlayer.play();
      videoPlayer.setAttribute('controls', true);
      button.style.display = 'none';
    });

    videoPlayer.onended = function(){
      videoPlayer.removeAttribute('controls');
      button.style.display = 'block';
    }
  });
}
